<template>

  <b-overlay
    id="overlay-background"
    :show="false"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card
      no-body
      class="card-payment"
    >
      <b-card-body>
        <b-tabs
          content-class="pt-1"
          fill
        >
          <!-- <b-tab
            active
            :title="$t('DEBTIA_GENERAL_SETTINGS')"
          >
            <general-settings />
          </b-tab>
          <b-tab
            ref="bcAPISettingsTab"
            :title="$t('DEBTIA_BC_API_SETTINGS')"
          >
            <bcapi-settings :settings="settings" />
          </b-tab> -->
          <b-tab
            :title="$t('DEBTIA_CONFIGS')"
          >
            <config-settings :settings="settings" />
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BTabs, BTab, BCard, BCardBody, BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import ConfigSettings from './ConfigSettings.vue'
// import BcapiSettings from './BCAPISettings.vue'
// import GeneralSettings from './generalSettings.vue'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardBody,
    ConfigSettings,
    // BcapiSettings,
    BOverlay,
    // GeneralSettings,
  },
  data() {
    return {
      // codeFill,
      loader: false,
      settings: [],
      apisettings: {},
      statementSettingValues: [],
    }
  },
  created() {
    this.settingsData()
    // this.getCommunicationApiSettings()
    // this.getStatementSettings()
    if (localStorage.getItem('landToAdminSettings')) this.landToAdminSettings()
  },
  methods: {
    landToAdminSettings() {
      localStorage.removeItem('landToAdminSettings')
      setTimeout(() => {
        this.$refs.bcAPISettingsTab.activate()
      }, 2000)
    },
    async settingsData() {
      this.loader = true
      await axios.get('payment/user-settings/list').then(response => {
        if (response.status) {
          this.settings = response.data.data
          this.loader = false
        }
      })
    },
    async getCommunicationApiSettings() {
      this.loader = true
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.apisettings = settings.data.data
          this.loader = false
        }
      })
    },
    async getStatementSettings() {
      this.loader = true
      axios.get('settings/get-statement-settings').then(response => {
        if (response.data.status) {
          this.statementSettingValues = response.data.data.statements
          this.statementSettingValues.forEach((item, index) => {
            if (item.status === true || item.status === 1) {
              this.statementSettingValues[index].status = true
            } else {
              this.statementSettingValues[index].status = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
